// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"to-z","badgeLink":"uo-z","category":"vo-z"};